import { FormInstance } from 'antd';
import { FullValidationErrorFragmentType } from '@common/graphql/fragments';

export const addErrorsToForm = (
  form: FormInstance,
  errors: FullValidationErrorFragmentType[]
) => {
  errors.forEach((error) => {
    const attribute = error.attribute;
    const antErrors = error.errors.map(
      (msg) => `${error.humanAttribute} ${msg}.`
    );
    const antValueWithError = { name: attribute, errors: antErrors };
    form.setFields([antValueWithError]);
    form.scrollToField(attribute);
  });
};

export const allFormErrors = (form: FormInstance) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: preserving previous js behavior (which might be wrong)
  const formData = form.getFieldValue();
  const formKeys = Object.keys(formData);
  const errors: string[][] = [];

  formKeys.forEach((key) => {
    if (form.getFieldError(key).length > 0) {
      errors.push(form.getFieldError(key));
    }
  });

  return errors;
};
